// partnerApi.js
// Authenticated calls for the restaurant-partner portal. Note there is no restaurantId
// parameter anywhere in here by design: the server derives it from the verified JWT, so
// a partner physically cannot request another restaurant's money or orders.

import { bearerToken, refresh, logout } from './partnerAuth';

const API_BASE = 'https://z51smv2b7g.execute-api.ap-southeast-2.amazonaws.com/prod';

async function authedFetch(path, options = {}, isRetry = false) {
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken()}`,
      ...(options.headers || {}),
    },
  });

  // One silent refresh attempt before giving up and sending them back to login.
  if (res.status === 401 && !isRetry) {
    try {
      await refresh();
      return authedFetch(path, options, true);
    } catch {
      logout();
      window.location.href = '/partner/login';
      throw new Error('Session expired');
    }
  }

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
}

export function getPartnerWallet() {
  return authedFetch('/partner/wallet');
}

export function requestPartnerCashout(amount) {
  return authedFetch('/partner/wallet', {
    method: 'POST',
    body: JSON.stringify(amount != null ? { amount } : {}),
  });
}

export function startPartnerOnboarding() {
  return authedFetch('/partner/connect-onboarding', { method: 'POST', body: JSON.stringify({}) });
}

export function getPartnerOrders() {
  return authedFetch('/partner/orders');
}

const partnerApi = { getPartnerWallet, requestPartnerCashout, startPartnerOnboarding, getPartnerOrders };
export default partnerApi;
